import { APIEndPoints } from "@api/endPoints";
import { APICaller } from "@api/request";
import { HTTPMethods } from "@enums/HttpMethods";
import { RequestContentType } from "@enums/RequestContentType";
import GetCampaigns from "@interfaces/GetCampaigns";

export const createCampaign = async (body: FormData, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.Campaign, HTTPMethods.POST, body, RequestContentType.FORM);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getCampaignList = async (queryParams: GetCampaigns, APICaller: APICaller) => {
    const queryObject: Record<string, string> = {};
    if (queryParams.current_page_number) {
        queryObject.current_page_number = String(queryParams.current_page_number);
    }
    if (queryParams.item_per_page) {
        queryObject.item_per_page = String(queryParams.item_per_page);
    }
    if (queryParams.is_published !== null) {
        queryObject.is_published = String(queryParams.is_published);
    }
    if (queryParams.start_date) {
        queryObject.start_date = String(queryParams.start_date);
    }
    if (queryParams.end_date) {
        queryObject.end_date = String(queryParams.end_date);
    }
    if (queryParams.search) {
        queryObject.search = String(queryParams.search);
    }
    if (queryParams.is_top_funded !== null) {
        queryObject.is_top_funded = String(queryParams.is_top_funded);
    }
    let query: string = new URLSearchParams(queryObject).toString();
    if (query.length > 0) {
        query = "?" + query;
    }
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.Campaign + query, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getMorePublicCampaigns = async (queryParams: GetCampaigns, APICaller: APICaller) => {
    const queryObject: Record<string, string> = {};
    if (queryParams.current_page_number) {
        queryObject.current_page_number = String(queryParams.current_page_number);
    }
    if (queryParams.item_per_page) {
        queryObject.item_per_page = String(queryParams.item_per_page);
    }
    if (queryParams.is_published !== null) {
        queryObject.is_published = String(queryParams.is_published);
    }
    if (queryParams.start_date) {
        queryObject.start_date = String(queryParams.start_date);
    }
    if (queryParams.end_date) {
        queryObject.end_date = String(queryParams.end_date);
    }
    if (queryParams.is_top_funded !== null) {
        queryObject.is_top_funded = String(queryParams.is_top_funded);
    }
    let query: string = new URLSearchParams(queryObject).toString();
    if (query.length > 0) {
        query = "?" + query;
    }
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.MorePublicCampaigns + query, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getDonatedCampaignList = async (campaign_list_viewer: string, APICaller: APICaller) => {
    const queryObject: Record<string, string> = {};
    if (campaign_list_viewer) {
        queryObject.campaign_list_viewer = String(campaign_list_viewer);
    }
    let query: string = new URLSearchParams(queryObject).toString();
    if (query.length > 0) {
        query = "?" + query;
    }
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.DonatedCampaign + query, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getCampaignDetails = async (slug: string, APICaller: APICaller, returnRecurringSupportedGateways: boolean = false) => {
    const queryObject: Record<string, string> = {};
    if (returnRecurringSupportedGateways) {
        queryObject.returnRecurringSupportedGateways = "true";
    }
    let query: string = new URLSearchParams(queryObject).toString();
    if (query.length > 0) {
        query = "?" + query;
    }

    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.Campaign + "/" + slug + query, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }
    return jsonResponse;
};

export const getCampaignTopDonors = async (slug: string, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.CampaignTopDonors.format(slug), HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }
    return jsonResponse;
};

export const updateCampaign = async (slug: string, body: FormData, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.Campaign + "/" + slug, HTTPMethods.POST, body, RequestContentType.FORM);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }
    return jsonResponse;
};

export const deleteCampaign = async (slug: string, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.Campaign + "/" + slug, HTTPMethods.DELETE);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }
    return jsonResponse;
};
